import axios from "./Axios";

// ComPass role codes that grant eFAST Filer access.
export const COMPASS_FILER_ROLE_CODES = ["company_officer"];

// eFAST role name of each ComPass role code returned by the token endpoint.
const COMPASS_ROLE_NAMES = {
  //added to allow login for other ComPass user level
  admin: "Filer",
  company_officer: "Filer",
  filer: "Filer",
};

// Resolves the eFAST role name of an account returned by the token endpoint.
// An account that only exists in ComPass carries no eFAST `role_name`, so its
// ComPass `role_code` is what decides how it files. Returns null when neither
// is known — the caller must not sign such an account in.
export const resolveRoleName = (user) =>
  (user && user.role_name) || COMPASS_ROLE_NAMES[user && user.role_code] || null;

const COMPASS_ACTIVE = 1;

const normalizeEmail = (email) => (email || "").trim().toLowerCase();

// Resolves the SEC registration no. of an eFAST company. Returns null on failure.
export const getCompanySecNo = async (companyId) => {
  if (!companyId) return null;

  try {
    const res = await axios.get(`/api/get_company/?id=${companyId}`);
    const company = Array.isArray(res.data) ? res.data[0] : res.data;
    return (company && company.sec_no) || null;
  } catch (error) {
    console.error("Failed to resolve SEC no. for ComPass lookup:", error);
    return null;
  }
};

// Looks up a company in ComPass and locates the signed-in user within it.
// `emails` is one address or a list of addresses that identify that same
// person. Never throws — a ComPass outage must leave the eFAST role untouched.
export const getCompassAccess = async ({ secNo, emails }) => {
  const access = { companyHasCompass: false, compassUser: null, isFiler: false };

  if (!secNo) return access;

  try {
    const res = await axios.get(
      `/api/compass/users-by-sec-no?sec_no=${encodeURIComponent(secNo)}`
    );
    const data = res.data || {};

    if (data.success !== true || !Array.isArray(data.users) || !data.total) {
      return access;
    }
    access.companyHasCompass = true;

    // The endpoint is company-scoped, so the signed-in user still has to be
    // found inside the returned list — "company has ComPass" is not enough.
    const targets = (Array.isArray(emails) ? emails : [emails])
      .map(normalizeEmail)
      .filter(Boolean);
    if (!targets.length) return access;

    const match = data.users.find(
      (user) =>
        targets.includes(normalizeEmail(user.email)) &&
        user.status === COMPASS_ACTIVE
    );
    if (!match) return access;

    access.compassUser = match;
    access.isFiler = COMPASS_FILER_ROLE_CODES.includes(match.role_code);
    return access;
  } catch (error) {
    console.error("ComPass lookup failed:", error);
    return access;
  }
};
